<template>
  <div
    class="content"
    :style="{
      backgroundImage:
        'url(' + require('@/assets/images/PTTSymmetryOscura02.jpg') + ')',
    }"
  >
    <div id="login">
      <div class="container">
        <div
          id="login-row"
          class="row justify-content-center align-items-center"
        >
          <div id="login-column" class="col-md-6">
            <div id="login-box" class="col-md-12 ">
              <div class="container mt-5" style="text-align: center;">
                <img
                  :src="logo"
                  @mouseover="logo = logo_blue"
                  @mouseout="logo = logo_white"
                  height="40"
                  alt=""
                  style="padding: 0"
                />
              </div>
              <p class="lead mt-3" style="text-align: center;">
                PASSWORD MAIL SEND
              </p>
              <p style="text-align: center;">
                Email was sent with instructions for the password change process
              </p>
              <div class="form-group" style="text-align: center;">
                <router-link
                  :to="{ name: 'login' }"
                  class="text-info text-title text-link"
                  style="text-align: center;"
                >
                  <p class="lead mt-3" style="text-align: center;">
                    <button class="btn btn-home" :disabled="loggingIn">
                      Back to login
                    </button>
                  </p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo_white: require("@/assets/images/QuanspireLogoWhite.svg"),
      logo_blue: require("@/assets/images/QuanspireLogoBlue.svg"),
      logo: require("@/assets/images/QuanspireLogoWhite.svg"),
    };
  },
  created() {},
  computed: {
    loggingIn() {
      return this.$store.state.authentication.loggingIn;
    },
  },
  methods: {},
};
</script>

<style scoped>
h1 {
  font-family: "Roboto", sans-serif !important;
  height: auto !important;
}

.wrapper {
  font-family: "Roboto", sans-serif !important;
  background: var(--darkbackground);
  width: 100%;
  height: calc(100vh - 65px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrapper.no-nav {
  height: 100vh;
}

.box {
  background: var(--darkbackground);
  width: 80%;
  height: 80%;
  border: 1px solid #fff;
  text-align: center;
  padding: 50px;
  position: relative;
}

.box.terms {
  overflow-y: scroll;
  color: #54595d;
}

.box.terms::-webkit-scrollbar {
  width: 18px;
}

.box.terms::-webkit-scrollbar-thumb {
  background-color: #979797;
  border-radius: 10px;
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
}

.box.terms img {
  width: 50px;
  border: 1px solid white;
  border-radius: 50%;
  padding: 5px;
  margin-right: 20px;
}

.box .terms-info {
  padding: 0 50px;
}

.box img {
  width: 350px;
}

.box h1 {
  letter-spacing: 1px;
  color: white;
  text-transform: uppercase;
  font-weight: 300;
  font-size: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box .back {
  position: absolute;
  left: 20px;
  top: 20px;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.terms-info-footer {
  display: flex;
  justify-content: space-around;
  padding: 30px 0;
}

.terms-info-footer .accept-button {
  color: #fff;
  background-color: #54595d;
  border: 3px solid #54595d;
  border-radius: 5px;
  padding: 8px 35px;
  font-weight: 700;
}

.terms-info-footer .accept-button:hover {
  text-decoration: none;
}

.terms-info-footer .decline-button {
  color: #54595d;
  border: 3px solid #54595d;
  border-radius: 10px;
  padding: 8px 35px;
  font-weight: 700;
}

.terms-info-footer .decline-button:hover {
  text-decoration: none;
}

.back-login {
  font-weight: 300;
  color: #54595d;
  font-size: 18px;
}

.back-login a {
  color: #54595d;
  text-decoration: underline;
}
</style>
